import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CENCentroConnectDataState from "@tCentro/Store/Reducer/CENCentroConnectDataState";

import { Draft } from "immer";

const initialState: CENCentroConnectDataState = {
    coworkers: [],
    expertiseCards: [],
    searchResults: null,
    isLoadingInitialData: false,
    isLoadingSearchResults: false,
    searchQuery: "",
};

export default createTypedReducerWithImmer(initialState, {
    "Custom/CentroConnect/BeginLoadInitialData": (draft: Draft<CENCentroConnectDataState>) => {
        draft.isLoadingInitialData = true;
    },
    "Custom/CentroConnect/CompleteLoadInitialData": (
        draft: Draft<CENCentroConnectDataState>,
        action: { coworkers: any[]; expertiseCards: any[] },
    ) => {
        draft.coworkers = action.coworkers;
        draft.expertiseCards = action.expertiseCards;
        draft.isLoadingInitialData = false;
    },
    "Custom/CentroConnect/FailedLoadInitialData": (draft: Draft<CENCentroConnectDataState>) => {
        draft.isLoadingInitialData = false;
    },
    "Custom/CentroConnect/BeginSearch": (draft: Draft<CENCentroConnectDataState>, action: { query: string }) => {
        draft.isLoadingSearchResults = true;
        draft.searchQuery = action.query;
    },
    "Custom/CentroConnect/CompleteSearch": (
        draft: Draft<CENCentroConnectDataState>,
        action: { searchResults: any },
    ) => {
        draft.searchResults = action.searchResults;
        draft.isLoadingSearchResults = false;
    },
    "Custom/CentroConnect/FailedSearch": (draft: Draft<CENCentroConnectDataState>) => {
        draft.isLoadingSearchResults = false;
    },
    "Custom/CentroConnect/ClearSearchResults": (draft: Draft<CENCentroConnectDataState>) => {
        draft.searchResults = null;
        draft.searchQuery = "";
    },
});
